import { Reference } from '../reference.model';
import { BaseEditableProperties, Widget } from './widget.model';

export type TextWidget = Widget & {
  widgetType: 'text';
  text?: string;
  // references and links are already defined in the base Widget - those are used as inline references and links
} & {
  localChanges?: TextWidgetLocalChanges;
};

export type TextWidgetLocalChanges = BaseEditableProperties &
  Partial<{
    text: string;
    references: Reference[];
  }>;

export const createTextWidget = (overrides?: Partial<Omit<TextWidget, 'widgetType'>>): TextWidget => ({
  widgetType: 'text',
  uniqueId: crypto.randomUUID(),
  references: [],
  attachments: [],
  links: [],
  ...overrides,
});
